import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShareNuggetProps } from "../../../src/type";
import { post } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const nuggetShare = createAsyncThunk(
  "share/feedback/nugget",
  async (requestData: ShareNuggetProps, storeActions) => {
    const url = `api/v1/user/feedback/nugget`;
    const response: any = await post(url, requestData, storeActions);

    if (response.status === HttpStatus.CREATED) {
      return {
        status: HttpStatus.CREATED,
      };
    }
    return {
      status: response.status,
    };
  }
);

const nuggetFeedbackSlice = createSlice({
  name: "nuggetFeedback",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      nuggetShare.fulfilled,
      (state, { payload }: PayloadAction<{ status: number | null }>) => {
        state.status = payload.status;
        state.loading = false;
      }
    );
    builder.addCase(nuggetShare.pending, (state) => {
      state.loading = true;
      state.status = null;
    });
    builder.addCase(nuggetShare.rejected, (state) => {
      state.status = 503;
      state.loading = false;
    });
  },
});

export const { clearData } = nuggetFeedbackSlice.actions;

export default nuggetFeedbackSlice;
